import React, { useState } from "react";
import { Button, Collapse } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import { Draggable } from "react-beautiful-dnd";
import jsDig from "utils/jsDig.js";
import metricCanBeBuilt from "utils/metricCanBeBuilt.js";
import { useEffect } from "react";
const handleSrc = require("images/icons/ui-handle.png");
const boxHandle = (
  <>
    <span className="box-handle-helper"></span>
    <img src={`/datapulse${handleSrc}`} className="handle-icon" />
  </>
);

export default function DashboardBuilderSection(props) {
  const year = new Date().getFullYear();
  const [isChecked, setIsChecked] = useState(jsDig(["enabled"], props.configData) === false ? false : true);

  const [clientDashboardOrder, setClientDashboardOrder] = useState(props.dashboards[props.currentDashboard].dashboardOrder);
  const [dashboards, setDashboards] = useState(props.dashboards);

  const changeHelper = () => {
    setIsChecked((isChecked) => !isChecked);
    console.log(isChecked);
  };

  const disableHelper = (metricName, id) => {
    const sections = ["searchSection", "displaySection", "socialSection", "videoSection", "seoSection", "ppcSection"];
    if (props.onboarding && props.configData.enabled === false) {
      return true;
    }
    if (!props.onboarding && isChecked === false) {
      return true;
    }
    if (props.sectionName === "goalsAndProjections") {
      if (id === 0) {
        let disabled = true;
        sections.forEach((section) => {
          if (props[section] && jsDig([section, "goals", year], props)) {
            const monthKeys = Object.keys(props[section].goals[year]);
            const allMetrics = monthKeys.map((month) => {
              return Object.keys(props[section].goals[year][month]);
            });
            let uniqueMetrics = new Set(allMetrics.flat());
            uniqueMetrics = Array.from(uniqueMetrics);
            if (uniqueMetrics.includes(metricName)) {
              disabled = false;
            }
          }
        });
        return disabled;
      } else if (props.service !== "seo") {
        let disabled = true;

        sections.forEach((section) => {
          if (props[section]) {
            let order = props[section].campaign_group_order.indexOf(id);
            if (
              jsDig([section, "campaign_groups", order, "goals", year], props) === undefined ||
              jsDig([section, "campaign_groups", order, "goals", year], props) === null
            ) {
              return true;
            } else {
              const monthKeys = Object.keys(jsDig([section, "campaign_groups", order, "goals", year], props));
              const allMetrics = monthKeys.map((month) => {
                return Object.keys(jsDig([section, "campaign_groups", order, "goals", year, month], props));
              });
              let uniqueMetrics = new Set(allMetrics.flat());
              uniqueMetrics = Array.from(uniqueMetrics);
              if (uniqueMetrics.includes(metricName)) {
                disabled = false;
              }
            }
          }
        });
        return disabled;
      } else {
        {
          let disabled = true;

          sections.forEach((section) => {
            if (props[section]) {
              let order = props[section].landing_page_group_order.indexOf(id);
              if (
                jsDig([section, "landing_page_groups", order, "goals", year], props) === undefined ||
                jsDig([section, "landing_page_groups", order, "goals", year], props) === null
              ) {
                return true;
              } else {
                const monthKeys = Object.keys(jsDig([section, "landing_page_groups", order, "goals", year], props));
                const allMetrics = monthKeys.map((month) => {
                  return Object.keys(jsDig([section, "landing_page_groups", order, "goals", year, month], props));
                });
                let uniqueMetrics = new Set(allMetrics.flat());
                uniqueMetrics = Array.from(uniqueMetrics);
                if (uniqueMetrics.includes(metricName)) {
                  disabled = false;
                }
              }
            }
          });
          return disabled;
        }
      }
    }
  };
  const [showConfig, setShowConfig] = useState(false);
  const arrowClass = showConfig ? "fa-caret-down" : "fa-caret-right";
  const fieldNames = `[dashboard_builder][${props.service}][${props.dashboardId}][${props.sectionName}]`;
  const fieldIds = `${props.service}_dashboard_${props.dashboardId}_${props.sectionData.name.snakeCase}`;
  const resetToDefault = () => {
    let allCheckboxes = $(`input[name*="${fieldNames}[metrics_data]"]`);
    allCheckboxes.prop("checked", false);
    Object.keys(props.defaultMetrics).forEach((metricName) => {
      let defaultCheckbox = $(`input[name*="${fieldNames}[metrics_data][${metricName}]"]`);
      defaultCheckbox.prop("checked", true);
      if (props.onboarding && props.setDashboard) {
        let newDashboardOrder = dashboards[props.currentDashboard].dashboardOrder;
        newDashboardOrder[props.index] = newDashboardOrder[props.index] || {};
        newDashboardOrder[props.index].metrics_data = newDashboardOrder[props.index].metrics_data || {};
        newDashboardOrder[props.index].metrics_data[metricName] = "1";
        let newDashboard = dashboards;
        newDashboard[props.currentDashboard].dashboardOrder = newDashboardOrder;
        props.setDashboard([...newDashboard]);
      }
    });
  };
  useEffect(() => {
    setDashboards([...props.dashboards]);
    setIsChecked(
      jsDig(
        ["enabled"],
        props.dashboards.find((el) => el.id == props.dashboardId).dashboardOrder.find((section) => section.name == props.sectionName)
      )
    );
    setClientDashboardOrder(props.dashboards[props.currentDashboard].dashboardOrder);
  }, [props.dashboards]);

  return (
    <>
      <input hidden readOnly name={`${fieldNames}[order]`} value={props.index} />
      <Draggable draggableId={props.sectionName} index={props.index}>
        {(provided) => (
          <div {...provided.draggableProps} ref={provided.innerRef} className="dashboard-builder-section d-flex">
            <div {...provided.dragHandleProps} className="dashboard-builder-section-handle px-2" style={{ backgroundColor: "#CACACA" }}>
              {boxHandle}
            </div>
            <div className="dashboard-builder-section-configuration d-flex flex-column px-4 py-3">
              <div className="dashboard-builder-section-check">
                {props.onboarding && dashboards !== undefined ? (
                  <CustomFormCheck
                    name={`${fieldNames}[enabled]`}
                    id={`${fieldIds}_enabled`}
                    label={`<h3>${props.sectionData.name.title}</h3>`}
                    checked={jsDig([props.currentDashboard, "dashboardOrder", props.index, "enabled"], dashboards)}
                    onChange={(e) => {
                      let newDashboardOrder = dashboards[props.currentDashboard].dashboardOrder;
                      newDashboardOrder[props.index] = newDashboardOrder[props.index] || {};
                      if (newDashboardOrder[props.index].enabled === true) {
                        newDashboardOrder[props.index].enabled = false;
                      } else {
                        newDashboardOrder[props.index].enabled = true;
                      }

                      if (props.onboarding && props.setDashboard) {
                        let newDashboard = dashboards;
                        newDashboard[props.currentDashboard].dashboardOrder = newDashboardOrder;
                        props.setDashboard([...newDashboard]);
                      }
                    }}
                  />
                ) : (
                  <CustomFormCheck
                    name={`${fieldNames}[enabled]`}
                    id={`${fieldIds}_enabled`}
                    label={`<h3>${props.sectionData.name.title}</h3>`}
                    checked={isChecked}
                    onChange={changeHelper}
                    sendUncheckedValue
                  />
                )}
              </div>
              <div>
                <div style={{ marginLeft: "25px" }} className="toggle-config d-flex row align-items-center pb-2" onClick={() => setShowConfig(!showConfig)}>
                  <p>Display configuration</p> <i className={`fas ${arrowClass} primary pl-2`}></i>
                </div>

                <Collapse in={showConfig}>
                  <div>
                    <ul className="metric-list">
                      {props.metricData &&
                        Object.entries(props.metricData)
                          .map((el) => {
                            return [el[1].name.title, el[0]];
                          })
                          .sort()
                          .map((item) => {
                            return item[1];
                          })
                          .map((metricName, index) => {
                            let metric = props.metricData[metricName];
                            if (metric) {
                              metric.name.title = (metric.name.title.trim()[0].toUpperCase() + metric.name.title.trim().slice(1).toLowerCase())
                                .replace("roas", "ROAS")
                                .replace("Cpc", "CPC")
                                .replace("Serp", "SERP")
                                .replace("ips", "IPs")
                                .replace("top", "Top");
                                if (props.service === "seo") {
                                  metric.name.title = (metric.name.title.trim()[0].toUpperCase() + metric.name.title.trim().slice(1).toLowerCase())
                                .replace("(inflated)", "")
                                .replace("Gsc", "GSC")
                                }
                              let label = metric.icon
                                ? `<img src="${metric.icon}" style="width: 20px; margin-top: -5px; margin-right: 10px" />${metric.name.title}`
                                : props.sectionData.name.title === "Spend Allocation" && props.service === "social"
                                ? metricName === "spend"
                                  ? metric.name.title
                                  : metric.name.title + " *"
                                : metric.name.title;

                              return (
                                <div key={metricName}>
                                  {metricCanBeBuilt(props.service, props.sectionName, metricName, props.subServiceDashboards, props.enabledServices) ? (
                                    <li key={metricName}>
                                      {props.onboarding ? (
                                        <CustomFormCheck
                                          name={`${fieldNames}[metrics_data][${metricName}]`}
                                          id={`${fieldIds}_${metric.name.snakeCase}_enabled`}
                                          label={label}
                                          disabled={disableHelper(metricName, props.dashboardId)}
                                          checked={
                                            !jsDig([props.currentDashboard, "dashboardOrder", props.index, "enabled"], dashboards)
                                              ? false
                                              : jsDig(["metrics_data", `${metricName}`], dashboards[props.currentDashboard].dashboardOrder[props.index]) ==
                                                  "1" && true
                                          }
                                          onChange={(e) => {
                                            let newDashboardOrder = dashboards[props.currentDashboard].dashboardOrder;
                                            if (!newDashboardOrder[props.index].metrics_data) newDashboardOrder[props.index].metrics_data = {};
                                            newDashboardOrder[props.index].metrics_data[`${metricName}`] =
                                              newDashboardOrder[props.index].metrics_data && newDashboardOrder[props.index].metrics_data[`${metricName}`] == "1"
                                                ? "0"
                                                : "1";
                                            if (props.onboarding && props.setDashboard) {
                                              let newDashboard = dashboards;
                                              newDashboard[props.currentDashboard].dashboardOrder = newDashboardOrder;
                                              props.setDashboard([...newDashboard]);
                                            }
                                          }}
                                        />
                                      ) : metricName == "averagePosition" ? (
                                        <div>
                                          <CustomFormCheck
                                            name={`${fieldNames}[metrics_data][${metricName}]`}
                                            id={`${fieldIds}_${metric.name.snakeCase}_enabled`}
                                            label={label}
                                            hoverText=" Average Position is the monthly average of all your rankings for the keywords in your campaign. For any keyword where you aren’t ranking, it will be calculated as a ranking of 100."
                                            disabled={disableHelper(metricName, props.dashboardId)}
                                            checked={
                                              isChecked === false
                                                ? false
                                                : clientDashboardOrder[props.index] &&
                                                  clientDashboardOrder[props.index].metrics_data &&
                                                  clientDashboardOrder[props.index].metrics_data[metricName] == "1"
                                                ? true
                                                : false
                                            }
                                            onChange={(e) => {
                                              let newDashboardOrder = dashboards[props.currentDashboard].dashboardOrder;

                                              if (!newDashboardOrder[props.index].metrics_data) newDashboardOrder[props.index].metrics_data = {};
                                              newDashboardOrder[props.index].metrics_data[`${metricName}`] =
                                                newDashboardOrder[props.index].metrics_data &&
                                                newDashboardOrder[props.index].metrics_data[`${metricName}`] == "1"
                                                  ? "0"
                                                  : "1";
                                              setClientDashboardOrder([...newDashboardOrder]);
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <CustomFormCheck
                                          name={`${fieldNames}[metrics_data][${metricName}]`}
                                          id={`${fieldIds}_${metric.name.snakeCase}_enabled`}
                                          label={label}
                                          disabled={disableHelper(metricName, props.dashboardId)}
                                          checked={
                                            isChecked === false
                                              ? false
                                              : clientDashboardOrder[props.index] &&
                                                clientDashboardOrder[props.index].metrics_data &&
                                                clientDashboardOrder[props.index].metrics_data[metricName] == "1"
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            let newDashboardOrder = dashboards[props.currentDashboard].dashboardOrder;
                                            console.log(newDashboardOrder);
                                            if (!newDashboardOrder[props.index].metrics_data) newDashboardOrder[props.index].metrics_data = {};
                                            newDashboardOrder[props.index].metrics_data[`${metricName}`] =
                                              newDashboardOrder[props.index].metrics_data && newDashboardOrder[props.index].metrics_data[`${metricName}`] == "1"
                                                ? "0"
                                                : "1";
                                            setClientDashboardOrder([...newDashboardOrder]);
                                            console.log(clientDashboardOrder);
                                          }}
                                        />
                                      )}{" "}
                                    </li>
                                  ) : (
                                    <div key={metricName}>
                                      <CustomFormCheck
                                        name={`${fieldNames}[metrics_data][${metricName}]`}
                                        id={`${fieldIds}_${metric.name.snakeCase}_enabled`}
                                        label={label}
                                        checked={false}
                                        static
                                        disabled
                                        hoverText="This metric cannot be built because it depends on other metrics which have not been selected"
                                      />
                                    </div>
                                  )}
                                </div>
                              );
                            } else {
                              return (
                                <li key={metricName}>
                                  <span style={{ color: "red" }}>{`${metricName} not defined in metricData`}</span>
                                </li>
                              );
                            }
                          })}
                    </ul>
                    <div className="mt-2">
                      <Button
                        style={{ paddingLeft: "30px", paddingRight: "30px" }}
                        className="mt-0 py-1 bg-blue"
                        onClick={resetToDefault}
                        as="input"
                        type="button"
                        size="sm"
                        value="Restore section defaults"
                      />
                      {props.sectionData.name.title === "Spend Allocation" && props.service === "social" && (
                        <p className="pt-2 pl-3 f12 d-inline">* Will populate only under day of week chart</p>
                      )}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        )}
      </Draggable>
    </>
  );
}
